import type { AxiosInstance } from "axios";

export type AdPlacementRecord = {
  id: string;
  zoneId: string;
  channel: string;
  title: string | null;
  description: string | null;
  cpi: number;
  cpc: number;
  active: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
};

export type ListAdPlacementsResponse = {
  adPlacements: AdPlacementRecord[];
};

export type AdPlacementsByChannel = Record<
  AdPlacementRecord["channel"],
  AdPlacementRecord[]
>;

export class AdPlacementsService {
  constructor(private readonly axios: AxiosInstance) {}

  async list(): Promise<AdPlacementRecord[]> {
    const response =
      await this.axios.get<ListAdPlacementsResponse>("/ad-placements");

    return response.data.adPlacements;
  }

  async listActive(): Promise<AdPlacementRecord[]> {
    const adPlacements = await this.list();

    return adPlacements.filter(
      (adPlacement) => adPlacement.active && !adPlacement.deleted,
    );
  }

  async listActiveGroupedByChannel(): Promise<AdPlacementsByChannel> {
    const adPlacements = await this.listActive();

    return adPlacements.reduce<AdPlacementsByChannel>((acc, adPlacement) => {
      if (!acc[adPlacement.channel]) {
        acc[adPlacement.channel] = [];
      }

      acc[adPlacement.channel].push(adPlacement);
      return acc;
    }, {} as AdPlacementsByChannel);
  }
}
